import { Outlet } from "react-router-dom";
import MainGrid from "../atoms/MainGrid/MainGrid";
import ErrorBoundary from "../atoms/ErrorBoundary/ErrorBoundary";

export const HomePageLayout = () => {
  return (
    <MainGrid>
      <ErrorBoundary>
        <Outlet />
      </ErrorBoundary>
    </MainGrid>
  );
};

export default HomePageLayout;
